export default {
  subheader: {
    fontSize: 20,
    fontWeight: 300,
    fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
    paddingLeft: 8,
    paddingRight: 8,
  },
  content: {
    maxWidth: 1200,
    marginTop: 32,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  loading: {
    padding: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  wrap: {
    flexWrap: 'wrap',
    marginTop: 16,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  checkbox: {
    width: 140
  },
  select: {
    marginLeft: 12, marginRight: 8, marginTop: 0, width: 100
  }
};



// WEBPACK FOOTER //
// ./src/styles/EmployeeHoliday.js